export default {
  productDetailsForm: null,
}
